import { fetchConToken } from '../utils/fetch.ts';


export const editarAlumnoGira = async (idalumno, data) => {
  try {
    const resp = await fetchConToken("giras/editar-alumno-gira", {
      idalumno,
      data
    }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const creaGira = async (gira) => {
    try {
      const resp = await fetchConToken("giras/crear-gira",gira, "POST");
      const body = await resp.json();
      return body;
    } catch (error) {
      return { error: true };
    }
  };

  
  export const editarGira = async (gira) => {
    try {
      const resp = await fetchConToken("giras/editar-gira",gira, "POST");
      const body = await resp.json();
      return body;
    } catch (error) {

      return { error: true };
    }
  };

  export const updateAlumno = async (editData) => {
    try {
      const resp = await fetchConToken("giras/editar-alumno", editData, "POST");
      const body = await resp.json();
      return body;
    } catch (error) {
      return { error: true };
    }
  };


export const getGiras = async () => {
  try {
    const resp = await fetchConToken("giras/listado-giras", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}; 

export const getGira = async (id) => {
  try {
    const resp = await fetchConToken(`giras/obtener-gira/${id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}  

export const getMiGira = async (id) => {
  try {
    const resp = await fetchConToken(`giras/obtener-mi-gira/${id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}  

export const descargarPlanillaAduana = async (id) => {
  
  try {
    const resp = await fetchConToken(`giras/descargar-planilla-aduana/${id}`, {}, "GET");
    const body = await resp.blob();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const descargarLogAcceso = async (id) => {
  try {
    const resp = await fetchConToken(`giras/descargar-log-acceso/${id}`, {}, "GET");
    const body = await resp.blob();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const descargarPlanillaInterna = async (id) => {
  try {
    const resp = await fetchConToken(`giras/descargar-planilla-interna/${id}`, {}, "GET");
    const body = await resp.blob();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const getApoderdosGiras = async (id) => {
  try {
    const resp = await fetchConToken(`giras/apoderados-gira/${id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const getAlumnosGira = async (id) => {
  try {
    const resp = await fetchConToken(`giras/alumnos-gira/${id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const getAlumno = async (id) => {
  try {
    const resp = await fetchConToken(`giras/alumno/${id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
} 


export const getAlumnosEliminadosGira = async (id) => {
  try {
    const resp = await fetchConToken(`giras/alumnos-eliminados-gira/${id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const getDocumentosGira = async (id) => {
  try {
    const resp = await fetchConToken(`giras/documentos-gira/${id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}



export const enviarListadoapoderados = async (idfile, idgira) => {
  try {
    const resp = await fetchConToken("giras/enviar-listado-apoderado", { idfile, idgira }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const enviarDocumentos = async (idfile, idgira) => {
  try {
    const resp = await fetchConToken("giras/enviar-documentos", { idfile, idgira }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const eliminarAlumnoGira = async (idalumno, idgira) => {
  try {
    const resp = await fetchConToken("giras/eliminar-alumno-gira", { idalumno, idgira }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const agregareliminarAlumnoGira  = async (idalumno, idgira, alumno) => {
  try {
    const resp = await fetchConToken("giras/activar-alumno-gira", { idalumno, idgira, alumno }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}


export const agregarAlumnoGira  = async (idapoderado, idgira, alumno) => {
  try {
    const resp = await fetchConToken("giras/agregar-alumno-gira", { idapoderado, idgira, alumno }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const cuotasAlumno = async (idalumno) => {
  try {
    const resp = await fetchConToken(`giras/cuotas-alumno/${idalumno}`, {}, "GET");
    const body = await resp.json();
    return body;
  }
  catch (error) {
    return { error: true };
  }
}

export const registrarPagosFuncionario = async (pagos,multasModificadas, detalleModificadas) => {
  try {
    const resp = await fetchConToken("giras/registrar-pagos-funcionario", {pagos,multasModificadas, detalleModificadas}, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const getMisGiras = async () => {
  try {
    const resp = await fetchConToken("giras/mis-giras", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}; 

//Pagos Webpay
export const registrarPagosWebpay = async (pagos) => {
  try {
    const resp = await fetchConToken("webpay/registrar-pagos-webpay", pagos, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}




export const commitPagosWebpay = async (tokenws) => {
  try {
    const resp = await fetchConToken("webpay/commit-pagos-webpay",{tokenws: tokenws}, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

//Pagos getnet
export const registrarPagosGetnet = async (pagos) => {
  try {
    const resp = await fetchConToken("getnet/registrar-pagos-getnet", pagos, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const commitPagosGetnet = async (tokenws) => {
  try {
    const resp = await fetchConToken("getnet/commit-pagos-getnet",{tokenws: tokenws}, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

//Pagos Khipu
export const registrarPagosKhipu = async (pagos) => {
  try {
    const resp = await fetchConToken("khipu/registrar-pagos-khipu", pagos, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}


export const commitPagosKhipu = async (tokenws) => {
  try {
    const resp = await fetchConToken("khipu/commit-pagos-khipu",{tokenws: tokenws}, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}







  export default {
    creaGira,
    editarGira,
    cuotasAlumno,
    registrarPagosFuncionario,
    getMisGiras
  }